import { useCallback } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import {
    SampleDataVersion,
    useBxpWebStargateClient
} from "@/libraries/bxp-web-stargate-client/src";

import { useSampleProjectConfiguration } from "../utils/sample-project";

import { useCloudStatus } from "./use-cloud-status";
import { useGupsStatus } from "./use-gups";

export const useCreateMatureExampleProjectV2 = () => {
    const { cloudId } = useCloudStatus();
    const stargateClient = useBxpWebStargateClient();
    const {
        teamType,
        projectDetails,
        sampleProjectConfiguration,
        v2SampleProjectConfiguration
    } = useSampleProjectConfiguration();
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const { addMatureExampleProjectIdsCallback } = useGupsStatus();

    const createMatureExampleProjectV2 = useCallback(async () => {
        try {
            const { projectId } = await stargateClient.sampleProjectCreate({
                cloudId,
                teamType: teamType,
                template: projectDetails.template,
                issueTypes: sampleProjectConfiguration.issueTypes,
                statusNames: v2SampleProjectConfiguration.columns,
                customDetail: {
                    sampleDataVersion: SampleDataVersion.MATUREV2,
                    enableExtraFields: true
                }
            });

            if (projectId !== "") {
                await addMatureExampleProjectIdsCallback([projectId], cloudId);

                createAnalyticsEvent({
                    eventType: "track",
                    action: "created",
                    actionSubject: "matureExampleProjectV2"
                }).fire();

                return projectId;
            }
        } catch (error) {
            console.error("Error creating sample project:", error);
            createAnalyticsEvent({
                eventType: "track",
                action: "failed",
                actionSubject: "matureExampleProjectV2",
                error
            }).fire();
        }

        return undefined;
    }, [
        stargateClient,
        cloudId,
        teamType,
        projectDetails,
        sampleProjectConfiguration
    ]);

    return { createMatureExampleProjectV2 };
};
